import type { DeepString } from "@/lib/i18n";

export const pl = {
  defaultTitle: "Opinie klientów",
  prev: "Poprzednia",
  next: "Następna",
  goToSlide: "Przejdź do referencji",
  readRealization: "Zobacz realizację",
} as const;

export type WClientTestimonialsTranslations = DeepString<typeof pl>;
